<ul class="flex gap-3 desktop:gap-5 justify-end flex-wrap" *ngIf="navigation">
  <li
    class="inline-flex items-center"
    *ngFor="let item of navigation | auth | async"
  >
    <a
      class="uppercase font-medium text-sm hover:underline whitespace-nowrap"
      [routerLink]="item['route']"
    >
      {{ item['label'] | translate }}
    </a>
  </li>
</ul>
